import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import { ManagedSettingsMdmOptionsComponent, MdmOptions } from './mdm-options.component';

@Component({
  selector: 'ml-mdm-options',
  templateUrl: './mdm-options.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ManagedSettingsMdmOptionsComponent],
})
export class ManagedSettingsMdmOptionsContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  mdmOptions(mdmOptions: MdmOptions) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.mDMOptions({
        udid: this.udid,
        activationLockAllowedWhileSupervised: mdmOptions.activationLockAllowedWhileSupervised,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
